import { combineReducers } from 'redux';

import kpi from '../../features/kpi/store/reducers';
import auth from '../../features/auth/store/reducers';

const rootReducer = (state, action) => {
  const appReducer = combineReducers({
    kpi,
    auth,
  });
  if (action.type === 'persist/REHYDRATE') {
    return {
      ...state,
      kpi: {
        ...(state?.kpi || {}),
        ...(action?.payload?.kpi || {}),
      }
    };
  }
  return appReducer(state, action);
};

export default rootReducer;
